module.exports = __webpack_public_path__ + "img/prize_panel_bg.80a42a23.png";